import React from 'react';

const Marquee = ({ direction = 'left' }) => {
  const animationClass = direction === 'right' ? 'ultra-marquee-right' : 'ultra-marquee-left';
  
  return (
    <>
      <style>
        {`
          @keyframes marqueeLeft {
            from { transform: translateX(0); }
            to { transform: translateX(-50%); }
          }
          @keyframes marqueeRight {
            from { transform: translateX(-50%); }
            to { transform: translateX(0); }
          }
          .ultra-marquee-left {
            animation: marqueeLeft 40s linear infinite;
            will-change: transform;
          }
          .ultra-marquee-right {
            animation: marqueeRight 40s linear infinite;
            will-change: transform;
          }
          .ultra-marquee-left:hover,
          .ultra-marquee-right:hover {
            animation-play-state: paused;
          }
        `}
      </style>
      
      <div className="relative overflow-hidden bg-black py-6 border-y border-white/5">
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-black/95 via-black/50 to-transparent z-10"></div>
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-black/95 via-black/50 to-transparent z-10"></div>
        
        <div className={`${animationClass} flex`} style={{ width: '200%' }}>
          {Array.from({ length: 25 }, (_, index) => (
            <div key={index} className="flex-none mx-8 md:mx-12 lg:mx-16">
              <img 
                src="https://res.cloudinary.com/dmrlotfsv/image/upload/v1754111081/VESHH-EON_TYPE_WHITE_f3gm0u.png" 
                className="h-7 md:h-9 lg:h-11 opacity-95 hover:opacity-100 hover:scale-105 transition-all duration-500 filter drop-shadow-lg" 
                alt="Veshh Eon Logo"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Marquee;
